module.exports = __webpack_public_path__ + "static/media/hero-baggage.faeee5c9.png";